<template>
  <transition name="slide-fade" >
    <div  id="academicsHolder" >
      <div class="uk-child-width-1-1" uk-grid>
        <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container uk-container-small">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              Opportunity is created, we design ways for it to be achieved.


            </p>
          </div>
        </div>-->

        <div class="uk-padding  uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <h1 class="uk-heading-line uk-text-center specHeading">Application Forms</h1>

            <div class="uk-child-width-1-2@m" uk-grid>
              <div class="uk-padding uk-text-center uk-visible@m">
                <img src="../assets/applicationform1.jpg" alt="">
              </div>
              <div class="uk-padding ">
                <ul class="uk-list uk-list-bullet ">
                  The application forms on this page are applicable to students who are:
                  <li>Student who are applying for the first time</li>
                  <li>Student who are re-applying after being dormant</li>
                </ul>
                <br>
<!--                <a href="/Application_form_Undergrad.pdf" target="_blank" class="uk-button uk-width-1-1 uk-button-primary">
                  <span uk-icon="download"></span>
                  Undergraduate Application Form
                </a>-->
                <br>
                <br>
<!--                <a href="/Graduate_Application_Form_Updated.pdf" target="_blank" class="uk-button uk-width-1-1 uk-button-secondary">
                  <span uk-icon="download"></span>
                  Graduate Application Form
                </a>-->
                <br>

              </div>
            </div>
          </div>
        </div>

        <div class="uk-padding uk-background-muted uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <h1 class="uk-heading-line uk-text-center specHeading">Medical Forms </h1>
            <span class="uk-text-small  uk-text-muted">Undergraduates Only</span>
            <br><br>

           <div uk-grid>
         <!--    <div class="uk-width-1-3@m">


                 <a href="../../../../static/dental.pdf" target="_blank" class="uk-button uk-width-1-1 uk-button-secondary">
                   <span uk-icon="download"></span>
                   Dental Form
                 </a>

             </div>-->
             <div class="uk-width-1-2@m">


                 <a href="/Updated_Medical_Form_2019.pdf" target="_blank" class="uk-button uk-width-1-1 uk-button-secondary">
                   <span uk-icon="download"></span>
                   Medical Form
                 </a>


             </div>
             <div class="uk-width-1-2@m">


                 <a href="/physical_examination.pdf" target="_blank" class="uk-button uk-width-1-1 uk-button-secondary">
                   <span uk-icon="download"></span>
                   Physical Form
                 </a>
                 <br>


             </div>

           </div>


            <div class="uk-margin-remove uk-margin-top" uk-grid>
              <div class="uk-width-1-1 uk-margin-remove uk-padding-remove">
                <br>
                <h3 class="uk-heading-bullet specHeading ">Guidelines for Completing Medicals</h3>
              </div>
            </div>
            <div class="uk-child-width-1-2@m uk-margin-remove-top" uk-grid>




              <div class="uk-padding uk-text-muted">

                <h4 class="uk-heading-bullet specHeading uk-text-muted">New and Re-accepted Students</h4>
                <div class="">
                  The following forms need to be completed:
                  <ul class="uk-list uk-list-divider">
                    <ul class="uk-list uk-list-bullet">
                      <li>Physical Examination Record Sheet.</li>
                      <li>Medical Report Form</li>
                      <!--<li>Dental Report</li>-->
                      <li>Immunization Record</li>
                    </ul>
                    <li>ALL laboratory investigations are to be done at a medical laboratory</li>

                    <li>Medicals MUST be submitted with laboratory findings</li>

                    <li>Medical Practitioner’s name, signature, address, and date of examination must be affixed to medical form.
                    </li>
                  </ul>
                </div>
              </div>
              <div class="uk-padding uk-text-muted">

                <h4 class="uk-heading-bullet specHeading uk-text-muted">Currently Enrolled Students</h4>
                <div class="">

                  <ul class="uk-list uk-list-divider">

                    <li>The Medical Report Form is the only form to be completed
                      and is to be done by a Medical Practitioner<!-- - No Dental
                      Report-->
                    </li>

                    <li>Hemoglobin and Urinalysis ONLY are required</li>

                    <li>Medicals MUST be submitted with laboratory findings</li>
                    <li>ALL laboratory investigations must be done at a medical laboratory.</li>
                    <li>Medical Practitioner’s name, signature, address, and date of examination must be affixed to medical form</li>
                  </ul>
                </div>
              </div>
              <div class="uk-width-1-1 uk-text-small uk-margin-remove-top" >

                All medicals are to be submitted in its full complement directly to the Health and Wellness Department at the Mandeville Campus in Manchester. A complete medical consists of:
                <br>
                 - Medical Report <br> -  Lab Results <br> - Physical Examination Record <br> -  Immunization Card
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </transition>
</template>

<script>
    export default {
        name: "applicationforms",
        mounted(){
          window.scrollTo(0, 0);
        },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Forms',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Forms for new and returning students of Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>
  @media screen and (max-width:600px){


    h3{
      font-size: 1.1em !important;
    }
    h1{
      font-size: 1.4em !important;
    }
    p,li{
      font-size: 0.8em !important;
    }


  }
</style>
